import { findValue } from "../utils";
import api from "./api";
import auth from "./auth";
// import newconfig from './newconfigfile'

export default function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var values = {
    api: api,
    auth: auth
    // newconfig
  };
  return findValue(value, values) || fallback;
}